import { useQuery } from '@tanstack/react-query';
import {
  IGetAllNotifications,
  IGetAllNotificationsBody,
} from "../../utils/types";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const useGetAllNotifications = (params: IGetAllNotificationsBody) =>
  useQuery({
    queryKey: ["get_all_notifications", params],
    queryFn: async (): Promise<IGetAllNotifications> => {
      const res = await apiClient.get(ENDPOINTS.ANNOUNCEMENTS.GET_ALL, {
        params
      });
      return res.data;
    },
  });